import { Component } from '@angular/core';

@Component({
  selector: 'app-client-detail-view',
  standalone: true,
  imports: [],
  templateUrl: './client-detail-view.component.html',
  styleUrl: './client-detail-view.component.css'
})
export class ClientDetailViewComponent {

}
